export const palette = {
  blue: '#549EE7',
  red: '#E85456',
  green: '#65BF65',
  magenta: '#9178E1',
  pink: '#D568D5',
  orange: '#C59445',
  cyan: '#62C7CC',
  yellow: '#D5D549',
  black: '#000000',
} as const;

export const residueColors: Record<string, string> = {
  A: palette.blue,
  R: palette.red,
  N: palette.green,
  D: palette.magenta,
  C: palette.pink,
  Q: palette.green,
  E: palette.magenta,
  G: palette.orange,
  H: palette.cyan,
  I: palette.blue,
  L: palette.blue,
  K: palette.red,
  M: palette.blue,
  F: palette.blue,
  P: palette.yellow,
  S: palette.green,
  T: palette.green,
  W: palette.blue,
  Y: palette.cyan,
  V: palette.blue,
  B: palette.black,
  X: palette.black,
  Z: palette.black,
};
